import { Module } from '@nestjs/common';

import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SizehtMatrixEntity } from '../po-bom/entittes/size-ht-matrix-entity';
import { SizeMatrixRepository } from './size-matrix.repo';
import { SizeMatrixService } from './size-matrix-service';
import { SizeMatrixController } from './size-matrix-controller';
import { SizeMatrixAdapter } from './adapter/size-matrix-adapter';

@Module({
  providers: [SizeMatrixService, ApplicationExceptionHandler,SizeMatrixRepository,SizeMatrixAdapter],
  imports: [
    TypeOrmModule.forFeature([
        SizehtMatrixEntity
  ])],
  controllers: [SizeMatrixController],
  exports:[SizeMatrixService]
})
export class SizeMatrixModule { }
